module.exports = __webpack_public_path__ + "img/1.8ee78f2e.png";